function Intro() {
    return (
        <>
        <section className="text-gray-600 body-font" style={{ backgroundColor: "#E6E6FA" }}>
            <div className="container mx-auto flex px-5 py-12 md:py-24 md:flex-row flex-col items-center">
                
                {/* Text Section */}
                <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col items-center text-center">
                    <h1 className="title-font sm:text-4xl text-3xl mb-8 font-bold text-black-900">
                        The One Childcare
                    </h1>
                    <p className="mb-8 leading-relaxed max-w-xl font-bold text-xl text-left">
                        We are a home nursery based in the Lee Green area of London, welcoming children aged from 8 months to 5 years. We offer a calm, nurturing space with a consistent adult-to-child ratio of 1 to 3.
                    </p>
                    <div className="flex justify-center">
                        <a href="#contact-us">
                            <button
                                className="inline-flex text-white font-semibold px-6 py-2 rounded text-lg transition-colors duration-200"
                                style={{ backgroundColor: "#5F9EA0" }}
                            >
                                Contact Us
                            </button>
                        </a>
                    </div>
                </div>

                {/* Image Section */}
                <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mt-8 md:mt-0">
                    <img
                        className="object-cover object-center rounded w-full h-auto shadow-md"
                        alt="hero"
                        src="/child-cropped.jpg"
                    />
                </div>
            </div>
        </section>
        </>
    );
}

export default Intro;
